import gamingLicenseLogo from './images/logo-license-white.png'

export default {
  gamingLicenseLogo
}
